/**
 * Endocrinologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: ENDO
 * Catalogue acts (NGAP Maroc): 0
 */
import { defineSpecialty } from "../types";

export const endocrinologie = defineSpecialty(
{
  "id": "endocrinologie",
  "label": "Endocrinologie",
  "short": "endocrinolog",
  "scope": "Diabète, thyroïde, métabolisme, obésité et pathologie surrénalienne",
  "aliases": [
    "ENDO"
  ],
  "doctorSpecs": [
    "Endocrinologie"
  ],
  "featureFlag": "ux.v2.endocrinologie",
  "theme": {
    "primary": "oklch(0.75 0.16 95)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "glycemia",
      "label": "Glycémie",
      "icon": "Droplet",
      "route": "/clinical/glycemia",
      "order": 2,
      "requires": []
    },
    {
      "id": "lab",
      "label": "Laboratoire",
      "icon": "FlaskConical",
      "route": "/clinical/lab",
      "order": 3,
      "requires": [
        "lims"
      ]
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "glycemia",
      "label": "Glycémie",
      "icon": "Droplet",
      "component": "GlycemiaPanel",
      "order": 1,
      "requires": []
    },
    {
      "id": "labs",
      "label": "Bilan",
      "icon": "FlaskConical",
      "component": "LabResultsGrid",
      "order": 2,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Endocrinologie",
    "subSpecialties": [
      "Consultation",
      "Diabétologie",
      "Thyroïdologie"
    ],
    "catalogueActs": 0
  },
  "terminology": {
    "icd10": [
      "E03",
      "E05",
      "E10",
      "E11",
      "E23"
    ],
    "loinc": [
      "1558-6",
      "3016-3",
      "4548-4"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "glucometer",
    "insulin-pump",
    "continuous-glucose-monitor"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default endocrinologie;
